// theme.ts
const KEY = "theme"; // "light" | "dark"

export function applyStoredTheme() {
	const t = localStorage.getItem(KEY);
	if (t === "light" || t === "dark") {
		document.documentElement.setAttribute("data-theme", t);
	} else {
		document.documentElement.removeAttribute("data-theme"); // let media query decide
	}
}

export function toggleTheme() {
	const current = document.documentElement.getAttribute("data-theme");
	const next = current === "dark" ? "light" : "dark";
	document.documentElement.setAttribute("data-theme", next);
	localStorage.setItem(KEY, next);
	return next;
}

applyStoredTheme();
